import { ApiClientImplementation } from 'infra/api-client/api-client'

import { PrepareApiRequestDecorator } from 'main/decorators/prepare-api-request-decorator/prepare-api-request-decorator'
import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'
import { ApiRepository } from 'repository/api-repository'
import { PatientRepository } from 'repository/repositories/patient/patient-repository'
import { RemoteInvitePatient } from 'service/usecases/invite-patient/remote-invite-patient'
import PatientService from 'presentation/contexts/services/patient-service'
import { RemoteLoadPatientByCpf } from 'service/usecases/load-patient-by-cpf/remote-load-patient-by-cpf'
import { RemoteSearchPatient } from 'service/usecases/search-patient/remote-search-patient'
import { RemoteLoadPatientInfo } from 'service/usecases/load-patient-info/remote-load-patient-info'
import { RemoteLoadPatientDocuments } from 'service/usecases/load-patient-documents/remote-load-patient-documents'
import { RemoteDownloadPatientDocument } from 'service/usecases/download-patient-document/remote-download-patient-document'
import { RemoteLoadPatientHideContact } from 'service/usecases/load-patient-hide-contact/remote-load-patient-hide-contact'
import { RemoteLoadPatientPossibleMotherName } from 'service/usecases/load-patient-possible-mother-name/remote-load-patient-possible-mother-name'
import { RemoteValidatePatientMotherAndBirthday } from 'service/usecases/validate-patient-mother-and-birthday/remote-validate-patient-mother-and-birthday'
import { RemoteValidateRegisteredPatientInDb } from 'service/usecases/validate-registered-patient-in-db/remote-validate-registered-patient-in-db'
import { RemoteInvitePatientFromMv } from 'service/usecases/invite-patient-from-mv/invite-patient-from-mv'
import { RemoteLoadPatientPendencies } from 'service/usecases/load-patient-pendencies/remote-load-patient-pendencies'
import { RemoteLoadPatientSchedules } from 'service/usecases/load-patient-schedules/remote-load-patient-schedules'
import { RemoteInviteNewBornPatient } from 'service/usecases/invite-newborn-patient/remote-invite-newborn-patient'
import { RemoteGetPatientNextAttendances } from 'service/usecases/get-patient-next-attendances/remote-get-patient-next-attendances'
import { RemoteUpdatePatientById } from 'service/usecases/update-patient-by-id/remote-update-patient-by-id'
import { RemoteGetPatientClassificationTypes } from 'service/usecases/get-patient-classification-types/remote-get-patient-classification-types'
import { RemoteGetPatientOrigins } from 'service/usecases/get-patient-origins/remote-get-patient-origins'

export default function makePatientService() {
  const apiRepository = new PrepareApiRequestDecorator(
    makeLocalStorageAdapter(),
    new ApiRepository(new ApiClientImplementation())
  )

  const patientRepository = new PatientRepository(apiRepository)

  const invitePatient = new RemoteInvitePatient(patientRepository)
  const loadPatientByCpf = new RemoteLoadPatientByCpf(patientRepository)
  const loadPatientInfo = new RemoteLoadPatientInfo(patientRepository)
  const searchPatient = new RemoteSearchPatient(patientRepository)
  const loadPatientDocuments = new RemoteLoadPatientDocuments(patientRepository)
  const loadPatientHideContact = new RemoteLoadPatientHideContact(
    patientRepository
  )
  const downloadPatientDocument = new RemoteDownloadPatientDocument(
    patientRepository
  )
  const loadPatientPossibleMotherName = new RemoteLoadPatientPossibleMotherName(
    patientRepository
  )
  const validatePatientMotherAndBirthday =
    new RemoteValidatePatientMotherAndBirthday(patientRepository)
  const validateRegisteredPatientInDb = new RemoteValidateRegisteredPatientInDb(
    patientRepository
  )
  const invitePatientFromMv = new RemoteInvitePatientFromMv(patientRepository)
  const loadPatientPendencies = new RemoteLoadPatientPendencies(
    patientRepository
  )
  const loadPatientSchedules = new RemoteLoadPatientSchedules(patientRepository)
  const inviteNewBornPatient = new RemoteInviteNewBornPatient(patientRepository)

  const getPatientNextAttendances = new RemoteGetPatientNextAttendances(
    patientRepository
  )

  const updatePatientById = new RemoteUpdatePatientById(patientRepository)
  const getPatientClassificationTypes = new RemoteGetPatientClassificationTypes(
    patientRepository
  )
  const getPatientOrigins = new RemoteGetPatientOrigins(patientRepository)

  return new PatientService({
    invitePatient,
    invitePatientFromMv,
    loadPatientByCpf,
    searchPatient,
    loadPatientInfo,
    loadPatientDocuments,
    downloadPatientDocument,
    loadPatientHideContact,
    loadPatientPossibleMotherName,
    validatePatientMotherAndBirthday,
    validateRegisteredPatientInDb,
    loadPatientPendencies,
    loadPatientSchedules,
    inviteNewBornPatient,
    getPatientNextAttendances,
    updatePatientById,
    getPatientOrigins,
    getPatientClassificationTypes
  })
}
